<template>
	<div class="conteudo-sistema">

		<div class="fl-cabecalho">
			<div class="row animated slideInDown">
				<div class="col-6">
					<h4><fa-icon icon="screwdriver" /> Manutenção</h4>
				</div>
				<div class="col-6">
				</div>
			</div>
		</div>

		<hr />

		<div class="row animated slideInDown">
			<div class="col-sm-4 form-group">
				<label>Fabricante:</label>
				<select v-model="form.idFabricante" @change="form.idModelo = ''; buscou = false"
					class="form-control form-control-sm">
					<option value="">ESCOLHA</option>
					<option v-for="item in fabricantes" :key="item.id" :value="item.id"> {{ item.descricao }}</option>
				</select>
			</div>
			<div class="col-sm-4 form-group">
				<label>Modelo:</label>
				<select v-model="form.idModelo" @change="buscou = false" class="form-control form-control-sm">
					<option value="">ESCOLHA</option>
					<option v-for="item in modelosFiltrados" :key="item.id" :value="item.id">{{ item.descricao }}</option>
				</select>
			</div>

			<div class="col-sm-2 form-group d-flex align-items-end">
				<button :disabled="form.idModelo == '' || form.idFabricante == ''" @click="clickCarregaModelo()"
					class="btn btn-sm btn-block btn-success">
					<fa-icon icon="sync-alt" /> CARREGAR
				</button>
			</div>
			<div class="col-sm-2 form-group d-flex align-items-end">
				<button :disabled="form.idModelo == '' || form.idFabricante == ''" @click="clickImportar()"
					class="btn btn-sm btn-block btn-success">
					<fa-icon icon="upload" /> IMPORTAR
				</button>
			</div>
		</div>

		<div class="card-categoria animated fadeIn" v-for="(cat, idxCate) in categorias" :key="idxCate">
			<div class="row">
				<div class="col-12 col-md-6 form-group">
					<p style="margin:0px; color: #3aa1ca">
						<span style="cursor:pointer;" @click="carregaCategorias(cat, idxCate)">
							<fa-icon icon="minus" v-if="cat._exibeCategoria" />
							<fa-icon icon="plus" v-if="!cat._exibeCategoria" />
							{{ cat.sigla }} - {{ cat.categoria }} - {{ cat.revisao }}
							<span v-if="cat.dataAtualizacao != '0001-01-01T00:00:00'"
								v-tooltip="$filters.formatDate(cat.dataAtualizacao)">
								<fa-icon icon="info-circle" />
							</span>
						</span>
					</p>
				</div>

				<div class="col-12 col-md-6 form-group">
					<button @click="abrirModalExcluirCategoria(cat)"
						class="btn btn-outline-danger float-right btn-sm btn-categoria">
						<fa-icon :icon="['far', 'trash-alt']" /> Excluir Categoria
					</button>

					<button v-if="cat.atualizacao == null" @click="clickAtualizacao(cat, null)"
						class="btn btn-outline-success float-right btn-sm btn-categoria">
						<fa-icon icon="plus" /> Nova Atualização
					</button>

					<button v-if="cat.atualizacao == null" @click="clickManual(cat, null)"
						class="btn btn-outline-success float-right btn-sm btn-categoria">
						<fa-icon icon="paper-plane" /> Enviar Manual
					</button>

					<button v-if="cat.atualizacao == null" @click="clickCopiar(cat)"
						class="btn btn-outline-success float-right btn-sm btn-categoria">
						<fa-icon :icon="['far', 'copy']" /> Copiar Manual
					</button>

					<button v-if="cat.atualizacao != null" @click="clickAtualizacao(cat, cat.atualizacao)"
						class="btn btn-success float-right btn-sm btn-categoria">
						<fa-icon icon="check" /> Concluír Atualização
					</button>

					<button v-if="cat.atualizacao != null" @click="confirmarExclusaoAtualizacao(cat.atualizacao)"
						class="btn btn-danger float-right btn-sm btn-categoria">
						<fa-icon icon="times" /> Excluir Atualização
					</button>

					<button v-if="cat._exibeCategoria && cat.atualizacao != null" @click="clickCategoria(cat)"
						class="btn btn-outline-secondary float-right btn-sm btn-categoria">
						<fa-icon icon="pencil-alt" /> Editar Categoria
					</button>
				</div>
			</div>

			<!-- <pre>{{cat._capitulos}}</pre> -->

			<div class="animated fadeIn slow" v-if="cat._exibeCategoria">

				<hr style="border-bottom: 1px solid #DDD; margin-top:0px; margin-bottom:0px">
				<div style="padding-left: 20px">
					<div class="row" v-if="cat._carregandoCategoria" style="margin-top:20px">
						<div class="col-xs-12">
							<flCarregando />
						</div>
					</div>

					<div class="row" style="margin-top:10px">
						<div class="col-12 col-md-8 form-group">
							<button type="button" v-if="cat.atualizacao != null" @click="clickCapitulo(cat, null)"
								class="btn btn-outline-info btn-sm">
								<fa-icon icon="plus" /> Novo Capítulo
							</button>
						</div>

						<div class="col-12 col-md-4 form-group">
							<flFind @key-up="(inputText) => buscaCategorias(cat, inputText)" placeholder="Buscar" />
						</div>
					</div>

					<div v-for="(cp, cpIdx) in cat._capitulos" :key="cpIdx" class="card-capitulos">

						<div class="row">
							<div class="col-12 col-md-6">
								<p style="margin-bottom:0px;margin-top:10px; margin-bottom:10px">
									<span style="cursor:pointer;" @click="carregaCapitulo(cat, idxCate, cp, cpIdx)">
										<fa-icon icon="minus" v-if="cp._exibeCapitulo" />
										<fa-icon icon="plus" v-if="!cp._exibeCapitulo" />
										{{ cp.nome }} - {{ cp.descricao }}
										<span v-if="cp.observacao" v-tooltip="cp.observacao">
											<fa-icon icon="info-circle" />
										</span>
									</span>
								</p>
							</div>

							<div class="col-12 col-md-6">
								<button @click="abrirModalExcluirCapitulo(cat, cp)"
									class="btn btn-outline-danger float-right btn-sm btn-categoria">
									<fa-icon :icon="['far', 'trash-alt']" /> Excluir Capitulo
								</button>

								<button type="button" v-if="cp._exibeCapitulo && cat.atualizacao != null"
									@click="clickCapitulo(cat, cp)"
									class="btn btn-outline-secondary float-right btn-sm btn-categoria">
									<fa-icon style="margin-top: -2px;" icon="pencil-alt" /> Editar Capítulo
								</button>
							</div>
						</div>


						<div class="row animated fadeIn slow" v-if="cp._exibeCapitulo && cat.atualizacao != null">
							<div class="col-md-12">
								<hr style="border-bottom: 1px solid #DDD; margin-top:0px; margin-bottom:8px">
							</div>
						</div>

						<div class="row" v-if="cp._exibeCapitulo">
							<div class="col-md-2 form-group">

								<button v-if="cat._exibeCategoria && cat.atualizacao != null && cp._exibeCapitulo"
									@click="clickInspecao(null, cat, cp)" class="btn btn-outline-info btn-sm">
									<fa-icon icon="plus" /> Nova Inspeção
								</button>

							</div>

							<div class="col-md-2 form-group">
								<div v-if="cp._exibeCapitulo && cat.atualizacao != null">
									<button v-tooltip="'Clique para ver todas'" type="button"
										v-show="cp._inspecoes.length != cp.inspecoes.length"
										@click="filtraInspecoes(cp, '')"
										class="btn btn-block btn-sm btn-outline-secondary">LIMPAR
									</button>
								</div>
							</div>

							<div class="col-md-5 form-group">

								<div v-if="cp._exibeCapitulo && cat.atualizacao != null" class="btn-group  btn-block">
									<button v-tooltip="'Clique para filtrar'" style="margin-top: 0rem;"
										@click="filtraInspecoes(cp, 'E')" type="button"
										class="btn btn-block btn-sm btn-outline-danger"> EXCLUÍDA ({{ cp._qtdExcluida }})
									</button>
									<button v-tooltip="'Clique para filtrar'" @click="filtraInspecoes(cp, 'A')"
										type="button" style="margin-top: 0rem;"
										class="btn btn-block btn-sm btn-outline-primary">ATUALIZADA ({{ cp._qtdAtualizada
										}})
									</button>
									<button v-tooltip="'Clique para filtrar'" @click="filtraInspecoes(cp, 'N')"
										type="button" style="margin-top: 0rem;"
										class="btn btn-block btn-sm btn-outline-success">ADICIONADA
										({{ cp._qtdNova }})</button>
								</div>
							</div>

							<div class="col-md-3 form-group">
								<flFind @key-up="(inputText) => buscaInspecoes(cp, inputText)" v-if="cp._exibeCapitulo"
									placeholder="Buscar" />
							</div>
						</div>

						<div class="row" v-if="cp._exibeCapitulo">
							<div class="col-md-12">
								<hr style="border-bottom: 1px solid #DDD; margin-top:8px; margin-bottom:0px">
							</div>
						</div>

						<div class="animated fadeIn slow" v-if="cp._exibeCapitulo">
							<div v-if="cp._carregandoInspecoes">
								<div class="col-xs-12" style="margin-top:8px; margin-bottom:8px">
									<flCarregando />
								</div>
							</div>

							<div :style="{ 'max-height': _height - 100 + 'px' }" class="box-inspecao"
								v-if="cp.inspecoes.length > 0">

								<div :style="{ 'background': getBk(item) }" class="card-inspecao"
									v-for="(item, index) in cp._inspecoes" :key="index">
									<flListaPadro :item="item" :editar="cat.atualizacao != null ? true : false"
										:categoria="cat" @click-editar="(item, cat) => clickInspecao(item, cat, null)"
										:exibeLegenda="true"></flListaPadro>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<button v-if="buscou" @click="clickCategoria(null)" class="btn btn-outline-info btn-sm"
			style="margin-top:8px; margin-right: 6px">
			<fa-icon icon="plus" /> Nova Categoria
		</button>

		<flModal @modal-hide="showFormInspecao = false" ref="modalInspecao" width="96%">
			<template v-slot:header>
				<span v-if="inspecao && !inspecaoVisualizar"><fa-icon icon="pen-alt" /> Editar</span>
				<span v-if="inspecaoVisualizar"><fa-icon icon="search" /> visualizar</span>
				<span v-if="!inspecao"><fa-icon icon="plus" /> Novo</span>
			</template>

			<flInspecao v-if="showFormInspecao" ref="inspecao" @item-salvo="atualizaInspecao" />
		</flModal>

		<flModal @modal-hide="showFormCapitulo = false" ref="modalCapitulo" width="50%">

			<template v-slot:header>
				<span v-if="capitulo"><fa-icon icon="pen-alt" /> Editar</span>
				<span v-if="!capitulo"><fa-icon icon="plus" /> Novo</span>
			</template>

			<flCapitulo v-if="showFormCapitulo" ref="capitulo" @item-salvo="atualizaCapitulo" />
		</flModal>

		<flModal @modal-hide="showFormImportar = false" ref="modalImportar" width="50%">

			<template v-slot:header>
				<span><fa-icon icon="upload" /> Importar</span>
			</template>

			<flImportar v-if="showFormImportar" ref="importar" @item-salvo="atualizaImportar" />
		</flModal>

		<flModal @modal-hide="showFormAtualizacao = false" ref="modalAtualizacao" width="50%">

			<template v-slot:header>
				<span v-if="atualizacao"><fa-icon icon="check" /> Concluir Atualização</span>
				<span v-if="!atualizacao"><fa-icon icon="plus" /> Nova Atualização</span>
			</template>

			<flAtualizacao v-if="showFormAtualizacao" ref="atualizacao" @item-salvo="atualizaAtualizacao" />
		</flModal>

		<flModal @modal-hide="showFormManual = false" ref="modalManual" width="50%">

			<template v-slot:header>
				<fa-icon icon="paper-plane" /> Enviar Manual
			</template>

			<flManual v-if="showFormManual" ref="manual" />
		</flModal>

		<flModal @modal-hide="showFormCopiar = false" ref="modalCopiar" width="50%">

			<template v-slot:header>
				<fa-icon :icon="['far', 'copy']" /> Copiar Manual
			</template>

			<flCopiarManual v-if="showFormCopiar" ref="copiar" />
		</flModal>

		<flModal @modal-hide="showFormCategoria = false" ref="modalCategoria" width="90%">

			<template v-slot:header>
				<span v-if="categoria"><fa-icon icon="pen-alt" /> Editar</span>
				<span v-if="!categoria"><fa-icon icon="plus" /> Nova</span>
			</template>

			<flCategoria v-if="showFormCategoria" ref="categoria" @item-salvo="atualizaCategoria" />
		</flModal>

		<flModal ref="modalExcluirCategoria" width="50%">

			<template v-slot:header>
				<span><fa-icon :icon="['far', 'trash-alt']" /> Excluir Categoria</span>
			</template>

			<fl-modal-opcoes-sim-nao titulo="Você deseja realmente remover está categoria ?" @sim="excluirCategoria"
				@nao="fecharModalExcluirCategoria" />
		</flModal>

		<flModal ref="modalExcluirCapitulo" width="50%">

			<template v-slot:header>
				<span><fa-icon :icon="['far', 'trash-alt']" /> Excluir Capítulo</span>
			</template>

			<fl-modal-opcoes-sim-nao titulo="Você deseja realmente remover este capítulo ?" @sim="excluirCapitulo"
				@nao="fecharModalExcluirCapitulo" />
		</flModal>
	</div>
</template>

<script>
import flListaPadro from "./modelo/lista.vue";
import flCategoria from "./cadastro/categoria.vue";
import flCapitulo from "./cadastro/capitulo.vue";
import flImportar from "./importar.vue";
import flInspecao from "./cadastro/inspecao/main.vue";
import flAtualizacao from "./cadastro/atualizacao.vue";
import flManual from "./cadastro/manual.vue";
import flCopiarManual from './cadastro/copiar.vue'
import flModal from '../../../components/modal/main.vue'
import flCarregando from '../../../components/carregando/main.vue'
import _ from 'lodash'
import axios from '../../../routers/axios'
import flFind from '../../../components/find/main.vue'
import flModalOpcoesSimNao from '../../../components/modal-opcoes-sim-nao/main.vue';

export default {
	components: {
		flListaPadro,
		flCategoria,
		flImportar,
		flCapitulo,
		flInspecao,
		flAtualizacao,
		flManual,
		flCopiarManual,
		flModal,
		flCarregando,
		flFind,
		flModalOpcoesSimNao
	},

	data() {
		return {
			fabricantes: [],
			modelos: [],
			load: true,
			buscou: false,
			atualizacoes: [],
			categorias: [],
			agrupamentos: [],
			servidoresEnvio: [],

			inspecao: null,
			inspecaoVisualizar: false,
			showFormInspecao: false,

			capitulo: null,
			showFormCapitulo: false,

			importar: null,
			showFormImportar: false,


			showFormCopiar: false,

			atualizacao: null,
			showFormAtualizacao: false,

			manual: null,
			showFormManual: false,

			categoria: null,
			showFormCategoria: false,

			payloadModalExcluirCategoria: {},
			payloadModalExcluirCapitulo: {},

			form: {
				idFabricante: "",
				idModelo: "",
				tipo: ""
			}
		};
	},

	mounted() {
		this.carregaDados();
	},

	computed: {
		modelosFiltrados() {
			return _.filter(this.modelos, m => { return this.form.idFabricante == m.idFabricante })
		},
	},

	methods: {
		getBk(item) {
			if (item.excluir == 1) {
				return "#FFCDD2";
			}

			if (item.inserir == 1) {
				return "#C8E6C9";
			}

			if (item.atualizar == 1) {
				return "#BBDEFB";
			}

			return "#FFF";
		},

		buscaCategorias(categoria, text) {

			if (text != '') {

				categoria._capitulos = _.filter(categoria.capitulos, capitulo => {
					let descricao = capitulo.descricao + ''.toLowerCase()
					let nome = capitulo.nome + ''.toLowerCase()
					let busca = text.toUpperCase()
					return descricao.indexOf(busca) > -1 ? true : nome.indexOf(busca) > -1
				})

			} else {
				categoria._capitulos = categoria.capitulos
			}

			this.$forceUpdate()
		},

		buscaInspecoes(capitulo, text) {

			if (text != '') {
				capitulo._inspecoes = _.filter(capitulo.inspecoes, inspecao => {
					let buscaText = ["ataTitle", "taskNumber", "taskTitle", "documentation", "description", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "c10", "c11", "c12", "c13", "c14", "c15", "c16", "c17", "c18", "c19", "c20", "c21", "c22", "c23", "c24", "c25", "c26", "c27", "c28", "c29", "c30", "descricaoSubstituida"]

					let existe = buscaText.some((column) => {
						var it = inspecao[column] + ''.toLowerCase()
						let tb = text.toUpperCase()
						return it.indexOf(tb) > -1
					});

					let existePN = _.filter(inspecao.pnInspecao, item => {
						var it = item.descricao + ''.toLowerCase()
						let tb = text.toUpperCase()
						return it.indexOf(tb) > -1
					})

					let existeMPN = _.filter(inspecao.mpnInspecao, item => {
						var it = item.descricao + ''.toLowerCase()
						let tb = text.toUpperCase()
						return it.indexOf(tb) > -1
					})

					return existe || existePN.length > 0 || existeMPN.length > 0
				})
			} else {
				capitulo._inspecoes = capitulo.inspecoes
			}

			this.$forceUpdate()
		},

		filtraInspecoes(categoria, filtro) {

			categoria._inspecoes = []

			if (filtro == '') {
				categoria._inspecoes = categoria.inspecoes
			} else {
				categoria._inspecoes = _.filter(categoria.inspecoes, inspecao => {

					if (filtro == 'E' && inspecao.excluir) {
						return true
					}
					if (filtro == 'N' && inspecao.inserir) {
						return true
					}
					if (filtro == 'A' && inspecao.atualizar) {
						return true
					}
					return false
				})

				if (categoria._inspecoes.length == 0) {
					categoria._inspecoes = categoria.inspecoes
				}
			}
			this.$forceUpdate()
		},

		carregaDados() {
			this.load = true;
			axios.get(this._getUrl("api/fabricante")).then(response => {
				this.fabricantes = response.data;

				axios.get(this._getUrl("api/modelo")).then(response => {
					this.load = false;
					this.modelos = response.data.map(item => {
						item.fabricante = _.find(this.fabricantes, o => {
							return o.id == item.idFabricante;
						});
						item.descricaoFabricante = item.fabricante.descricao;
						return item;
					});
				});
			});

			axios.get(this._getUrl("api/ServidorEnvio")).then(response => {
				this.servidoresEnvio = response.data;
			})
		},

		clickInspecao(inspecao, categoria, capitulo) {

			this.inspecao = inspecao
			this.inspecaoVisualizar = categoria.atualizacao == null ? true : false
			this.showFormInspecao = true
			this.$refs.modalInspecao.show()

			this.$nextTick(() => {
				this.$refs.inspecao.carregaDados(
					categoria,
					inspecao,
					categoria.atualizacao == null ? true : false,
					capitulo
				);
			});
		},

		atualizaInspecao(inspecao) {

			let indexCategoria = _.findIndex(this.categorias, o => { return o.id == inspecao.idConfigInspecao; });
			let indexCapitulo = _.findIndex(this.categorias[indexCategoria].capitulos, o => { return o.id == inspecao.idCapitulo; });
			let indexInspecao = _.findIndex(this.categorias[indexCategoria].capitulos[indexCapitulo].inspecoes, o => { return o.id == inspecao.id; });

			if (indexInspecao > -1) {

				// remove da lista pq foi adicionado uma inspeção, não enviou para o cliente e depois excluiu
				//				if(inspecao.excluir && inspecao.inserir){
				//					console.log(indexCategoria);
				//					console.log(indexCapitulo);
				//					console.log(indexInspecao);
				//					console.log(inspecao);
				//					console.log(this.categorias[indexCategoria].capitulos[indexCapitulo].inspecoes[indexInspecao]);
				////					this.categorias[indexCategoria].capitulos[indexCapitulo].inspecoes.splice(indexInspecao, 1)
				//				} else {
				this.categorias[indexCategoria].capitulos[indexCapitulo].inspecoes[indexInspecao] = inspecao;
				//				}
			} else {
				this.categorias[indexCategoria].capitulos[indexCapitulo].inspecoes.push(inspecao);

				this.$forceUpdate();
			}

			// processa a quantidade de itens
			this.categorias[indexCategoria].capitulos[indexCapitulo].inspecoes = this.processaCapitulo(this.categorias[indexCategoria].capitulos[indexCapitulo])
			this.categorias[indexCategoria].capitulos[indexCapitulo]._inspecoes = this.categorias[indexCategoria].capitulos[indexCapitulo].inspecoes

			this.$refs.modalInspecao.hide()
			this.$notify.show('success', 'Inspeção salva')
		},

		atualizaCapitulo(capitulo) {

			let indexCategoria = _.findIndex(this.categorias, o => { return o.id == capitulo.idConfigInspecao; });
			let indexCapitulo = _.findIndex(this.categorias[indexCategoria].capitulos, o => { return o.id == capitulo.id; });

			// existe
			if (indexCapitulo > -1) {
				this.categorias[indexCategoria].capitulos[indexCapitulo].descricao = capitulo.descricao;
				this.categorias[indexCategoria].capitulos[indexCapitulo].nome = capitulo.nome;
				this.categorias[indexCategoria].capitulos[indexCapitulo].observacao = capitulo.observacao;
			} else {

				capitulo._exibeCapitulo = false;
				capitulo.inspecoes = [];
				capitulo._inspecoes = [];
				capitulo._carregandoInspecoes = false;
				this.categorias[indexCategoria].capitulos.push(capitulo);
				let index = this.categorias[indexCategoria].capitulos.length - 1
				this.carregaCapitulo(this.categorias[indexCategoria], indexCategoria, this.categorias[indexCategoria].capitulos[index], index)
			}

			this.$forceUpdate()

			this.$refs.modalCapitulo.hide()
			this.$notify.show('success', 'Capítulo salvo.')
		},

		atualizaImportar() {
			/*
						let indexCategoria = _.findIndex(this.categorias, o => {return o.id == capitulo.idConfigInspecao;});
						let indexCapitulo = _.findIndex(this.categorias[indexCategoria].capitulos,o => {return o.id == capitulo.id;});
			
						// existe
						if (indexCapitulo > -1) {
							this.categorias[indexCategoria].capitulos[indexCapitulo].descricao = capitulo.descricao;
							this.categorias[indexCategoria].capitulos[indexCapitulo].nome = capitulo.nome;
							this.categorias[indexCategoria].capitulos[indexCapitulo].observacao = capitulo.observacao;
						} else {
			
							capitulo._exibeCapitulo = false;
							capitulo.inspecoes = [];
							capitulo._inspecoes = [];
							capitulo._carregandoInspecoes = false;
							this.categorias[indexCategoria].capitulos.push(capitulo);
							let index = this.categorias[indexCategoria].capitulos.length - 1
							this.carregaCapitulo(this.categorias[indexCategoria], indexCategoria, this.categorias[indexCategoria].capitulos[index], index)
						}
			
						this.$forceUpdate()  */

			this.$refs.modalCapitulo.hide()
			this.$notify.show('success', 'Importação realizada.')
		},

		atualizaCategoria(categoria) {

			let index = _.findIndex(this.categorias, o => {
				return o.id == categoria.id;
			});
			if (index > -1) {

				this.categorias[index].categoria = categoria.categoria;
				this.categorias[index].sigla = categoria.sigla;
				this.categorias[index].revisao = categoria.revisao;
				this.categorias[index].template = categoria.template;
				this.categorias[index].dataAtualizacao = categoria.dataAtualizacao;
				this.categorias[index].substituida = categoria.substituida;
				this.categorias[index].adBoletim = categoria.adBoletim;
				this.categorias[index].formulario = categoria.formulario;
				this.categorias[index].c1 = categoria.c1;
				this.categorias[index].c2 = categoria.c2;
				this.categorias[index].c3 = categoria.c3;
				this.categorias[index].c4 = categoria.c4;
				this.categorias[index].c5 = categoria.c5;
				this.categorias[index].c6 = categoria.c6;
				this.categorias[index].c7 = categoria.c7;
				this.categorias[index].c8 = categoria.c8;
				this.categorias[index].c9 = categoria.c9;
				this.categorias[index].c10 = categoria.c10;
				this.categorias[index].c11 = categoria.c11;
				this.categorias[index].c12 = categoria.c12;
				this.categorias[index].c13 = categoria.c13;
				this.categorias[index].c14 = categoria.c14;
				this.categorias[index].c15 = categoria.c15;
				this.categorias[index].c16 = categoria.c16;
				this.categorias[index].c17 = categoria.c17;
				this.categorias[index].c18 = categoria.c18;
				this.categorias[index].c19 = categoria.c19;
				this.categorias[index].c20 = categoria.c20;
				this.categorias[index].c21 = categoria.c21;
				this.categorias[index].c22 = categoria.c22;
				this.categorias[index].c23 = categoria.c23;
				this.categorias[index].c24 = categoria.c24;
				this.categorias[index].c25 = categoria.c25;
				this.categorias[index].c26 = categoria.c26;
				this.categorias[index].c27 = categoria.c27;
				this.categorias[index].c28 = categoria.c28;
				this.categorias[index].c29 = categoria.c29;
				this.categorias[index].c30 = categoria.c30;
			} else {
				categoria._exibeCategoria = false;
				categoria._carregandoCategoria = false;
				categoria.capitulos = [];

				this.categorias.push(categoria);
			}

			this.showFormCategoria = false
			this.$refs.modalCategoria.hide()

			this.$notify.show('success', 'Categoria salva.')
		},

		atualizaAtualizacao(atualizacao) {
			let indexAtualizacao = _.findIndex(this.atualizacoes, o => {
				return o.id == atualizacao.id;
			});

			if (indexAtualizacao > -1) {
				this.atualizacoes[indexAtualizacao] = atualizacao;
				this.clickCarregaModelo();
			} else {
				this.atualizacoes.push(atualizacao);
				this.clickCarregaModelo();
			}

			this.processaAtualizacao()

			this.$refs.modalAtualizacao.hide()

			this.$notify.show('success', 'Atualização salva.')

		},

		processaAtualizacao() {
			this.categorias = this.categorias.map(item => {

				let atualizacao = _.find(this.atualizacoes, o => {
					return o.idConfigInspecao == item.id && o.status == "A";
				});


				if (_.isNil(atualizacao)) {
					item.atualizacao = null;
				} else {
					item.atualizacao = atualizacao;
				}

				return item;
			});
		},

		clickAtualizacao(categoria, atualizacao) {

			this.atualizacao = atualizacao
			this.showFormAtualizacao = true

			this.$refs.modalAtualizacao.show()

			this.$nextTick(() => {
				this.$refs.atualizacao.carregaDados(categoria, atualizacao);
			});
		},

		confirmarExclusaoAtualizacao(atualizacao) {
			const confirmacao = confirm('Ao deletar, toda as alterações feitas serão perdidas, e a ultima versão do manual será reativada. Deseja continuar?')
			if (confirmacao) {
				this.excluirAtualizacao(atualizacao.id)
			}
		},

		excluirAtualizacao(atualizacaoId) {
			axios.delete(this._getUrl(`api/atualizacaoManutencao/${atualizacaoId}`)).then((retorno) => {
				this.clickCarregaModelo()
			})
		},

		clickCopiar(categoria) {

			this.showFormCopiar = true
			this.$refs.modalCopiar.show()

			this.$nextTick(() => {
				this.$refs.copiar.carregaDados(categoria,
					_.filter(this.modelos, item => { return this.form.idFabricante == item.idFabricante }))
			})
		},

		clickManual(categoria, manual) {

			this.manual = manual
			this.showFormManual = true
			this.$refs.modalManual.show()

			this.$nextTick(() => {
				this.$refs.manual.carregaDados(categoria, this.servidoresEnvio);
			});
		},

		clickCapitulo(categoria, capitulo) {

			this.capitulo = capitulo
			this.showFormCapitulo = true

			this.$refs.modalCapitulo.show()

			this.$nextTick(() => {
				this.$refs.capitulo.carregaDados(categoria, capitulo);
			});

		},

		clickImportar() {

			this.$refs.modalImportar.show()

			this.$nextTick(() => {
				this.$refs.importar.carregaDados();
			});

		},

		clickCategoria(categoria) {

			this.categoria = categoria
			this.showFormCategoria = true

			this.$refs.modalCategoria.show()

			this.$nextTick(() => {
				this.$refs.categoria.carregaDados(categoria, this.form.idModelo);
			});
		},

		clickCarregaModelo() {
			this.$notify.loadIn('Carregando');

			axios.get(this._getUrl("api/atualizacaoManutencao")).then(rr => {
				if (_.isArray(rr.data)) {
					this.atualizacoes = rr.data;
				}

				axios.get(this._getUrl("api/configinspecaomodelo/" + this.form.idModelo)).then(response => {
					this.buscou = true
					if (_.isArray(response.data)) {
						this.categorias = response.data.map(item => {
							item._atualizacao = null;
							item._exibeCategoria = false;
							item._carregandoCategoria = false;
							item.capitulos = [];
							return item;
						});

						this.processaAtualizacao();
					}
				});
			});
		},

		carregaCategorias(item, index) {

			item._capitulos = []

			if (!item._exibeCategoria) {
				item._exibeCategoria = true;

				if (item.capitulos.length == 0) {
					item._carregandoCategoria = true;
					axios.get(this._getUrl("api/ConfigInspecaoCapitulo/" + item.id)).then(response => {
						if (_.isArray(response.data)) {
							item.capitulos = response.data.map(item => {
								item._exibeCapitulo = false;
								item._carregandoInspecoes = false;
								item.inspecoes = [];
								return item;
							});
						}

						item._capitulos = item.capitulos

						item._carregandoCategoria = false;
					});
				} else {
					item._capitulos = item.capitulos
				}
			} else {
				item._exibeCategoria = false;
				item._capitulos = item.capitulos
			}

			// this.$forceUpdate()
		},

		carregaCapitulo(item, indexCat, cp, index) {
			if (cp._exibeCapitulo == false) {
				cp._exibeCapitulo = true;
				if (cp.inspecoes.length == 0) {
					cp._carregandoInspecoes = true;
					cp._inspecoes = [];

					axios.get(this._getUrl("api/inspecao/" + cp.id + "/" + item.id)).then(response => {
						if (_.isArray(response.data)) {
							cp.inspecoes = response.data

							cp.inspecoes = this.processaCapitulo(cp)

							cp._inspecoes = cp.inspecoes
						}

						cp._carregandoInspecoes = false;
					});
				}
			} else {
				cp._exibeCapitulo = false;
			}
		},

		processaCapitulo(cp) {
			cp._qtdNova = 0;
			cp._qtdAtualizada = 0;
			cp._qtdExcluida = 0;

			return cp.inspecoes.map(inspecao => {

				if (inspecao.atualizar) cp._qtdAtualizada += 1
				if (inspecao.excluir) cp._qtdExcluida += 1
				if (inspecao.inserir && !inspecao.excluir) cp._qtdNova += 1

				return inspecao
			});
		},

		abrirModalExcluirCategoria(categoria) {
			this.payloadModalExcluirCategoria = { categoria }
			this.$refs.modalExcluirCategoria.show()
		},

		fecharModalExcluirCategoria() {
			this.payloadModalExcluirCategoria = {}
			this.$refs.modalExcluirCategoria.hide()
		},

		excluirCategoria() {
			axios.delete(this._getUrl(`rotaBackEnd`)).then((retorno) => {
			})
		},

		abrirModalExcluirCapitulo(categoria, capitulo) {
			this.payloadModalExcluirCapitulo = { capitulo }
			this.$refs.modalExcluirCapitulo.show()

		},

		fecharModalExcluirCapitulo() {
			this.payloadModalExcluirCapitulo = {}
			this.$refs.modalExcluirCapitulo.hide()
		},

		excluirCapitulo() {

			if (this.payloadModalExcluirCapitulo.capitulo.id) {
				axios.delete(this._getUrl(`api/capitulo/${this.payloadModalExcluirCapitulo.capitulo.id}`)).then((retorno) => {
					//	this.$notify.loadIn('Salvando');
					this.clickCarregaModelo()
				})
			}

			this.$refs.modalExcluirCapitulo.hide()

		}
	}
};
</script>

<style>
.card-manutencao {
	cursor: pointer;
	float: right;
	padding: 0.55em 0.7em;
	font-size: 0.7rem;
	margin-left: 6px;
	border-radius: 4px;
}

.box-inspecao {
	overflow-y: auto;
	margin-bottom: 20px;
	overflow-x: hidden;
}

.btn-categoria {
	margin-left: 6px;
	margin-bottom: 6px
}

.card-categoria {
	border: 1px solid #DDD;
	padding: 8px;
	background: #FFF;
}

.card-capitulos {
	background: #F0F0F0;
	padding: 4px 8px;
	border-radius: 4px;
	margin-bottom: 4px
}

.card-inspecao {
	margin-top: 10px;
	padding-left: 10px;
	padding-top: 10px;
	padding-right: 10px;
	border-radius: 8px
}
</style>



// WEBPACK FOOTER //
// src/views/followair/manutencao/main.vue